import React, { Component } from 'react';
import { withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import Api from '../../utils/api';

function isCalendlyEvent(e) {
    return e.data.event &&
           e.data.event.indexOf('calendly') === 0;
  }

class GateFeeBoarding_thank extends Component {
    constructor(props) {
        super(props);

        this.fun_openCalendly = this.fun_openCalendly.bind(this);
        this.fun_changeStepStep = this.fun_changeStepStep.bind(this);
        this.fun_scheduleConsult_record = this.fun_scheduleConsult_record.bind(this);

        this.state = {}
        var _this = this;
        window.addEventListener(
            'message',
            function(e) {
              if (isCalendlyEvent(e)) {
                  try {
                    if(e.data['event'] == "calendly.event_scheduled"){
                        _this.fun_scheduleConsult_record();
                      }
                  } catch (error) {
                    console.error(error);
                  }
              }
            }
          );
    }
    componentDidMount() {
        try {
            let overDom = document.getElementsByName("newBoardingThankView");
            if(overDom){
              let height1 = document.getElementById('promo-banner-container-second').offsetHeight
              overDom[0].style.top = (height1+47)+'px';
              let stepsDom = document.getElementsByClassName("quiz-steps-container");
              stepsDom[0].style.top = (height1)+'px';
            }
        } catch (error) {
        }
    }

    fun_openCalendly(){
        window.Calendly.initPopupWidget({url: 'https://calendly.com/helloavaconsults'});
    }

    fun_changeStepStep(){
        this.props.fun_changeStepStep();
    }

    // 是否已经做了咨询安排
    fun_scheduleConsult_record(){
        fetch("/api/user-flags", {
            method: 'PATCH',
            headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-auth-token': Api.auth_tokenManager()
            },
            body: window.JSON.stringify({
                    userId: localStorage.getItem("user_id"),
                    scheduleConsult: true
            })
        }) .then(response => {
            localStorage.setItem("visited_scheduleConsult",true);
            this.fun_changeStepStep();
        }).error(()=>{
            this.fun_changeStepStep();
        })
    }


   

    render() {
        return (
            <div className="pay-thank-container">
                <div className="paragraphSemiBold0 pay-thank-container-title">Thank you! <br></br> Schedule your consultation now</div>
                <img className="pay-thank-container-img" src="images/onboardingAA/gateFeeBoarding/payThank.png"></img>
                <button style={{marginTop:'18px'}} onClick={this.fun_openCalendly} className="p-a-n-button">Schedule your consult</button>
            </div>        
        )
    }
}

export default withRouter(connect()(GateFeeBoarding_thank))



// WEBPACK FOOTER //
// ./src/views/onboardingAA/GateFeeBoarding_thank.js